
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'antd/dist/antd.less';
import '@/styles/globals.scss';

ReactDOM.render(
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>,
  <App />,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Global handler: catch unhandled promise rejections and downgrade known
// browser-extension message-channel errors to warnings so they don't obscure
// real app errors during development.
window.addEventListener('unhandledrejection', (ev: PromiseRejectionEvent) => {
  try {
    const reason: any = ev.reason
    const msg = typeof reason === 'string' ? reason : (reason && reason.message) || ''
    // Known Chrome extension IPC issue message substring:
    const marker = 'A listener indicated an asynchronous response by returning true'
    if (msg && msg.indexOf(marker) !== -1) {
      // Log as a warning and prevent the default console error flooding
      console.warn('Ignored extension message-channel error:', reason)
      ev.preventDefault()
      return
    }
    // Also handle the unchecked runtime.lastError variant
    if (msg && msg.indexOf('Unchecked runtime.lastError') !== -1) {
      console.warn('Ignored unchecked runtime.lastError:', reason)
      ev.preventDefault()
      return
    }
  } catch (e) {
    // fall through to default handling
  }
  // For other unhandled rejections, keep default behavior but also log once
  console.error('Unhandled promise rejection:', ev.reason)
})
